import { useMemo } from 'react';

import { NameAndCreateDateFormatter } from '@Components/Grid/components/Table/formatters'
import { defaultColumn, defaultActionsColumn, deleteAction, editAction, defaultColumnId, defaultActiveColumn } from '@Components/Grid/utils/column';

export default function useColumns() {
  return useMemo(() => [
    defaultColumnId(),
    defaultColumn('name', 'Name', info => <NameAndCreateDateFormatter info={info} />),
    defaultColumn('location', 'Location'),
    defaultActiveColumn(),
    defaultActionsColumn(editAction, deleteAction),
  ], [])
}
